// extracted by mini-css-extract-plugin
export var blue = "_1x-f";
export var brand = "_1x-b";
export var darkGrey = "_1x-e";
export var disabled = "_1x-4";
export var disabledSubtle = "_1x-5";
export var error = "_1x-6";
export var green = "_1x-g";
export var grey = "_1x-d";
export var icon = "_1x-0";
export var inherit = "_1x-a";
export var lightGrey = "_1x-c";
export var orange = "_1x-i";
export var pink = "_1x-k";
export var primary = "_1x-1";
export var purple = "_1x-l";
export var red = "_1x-j";
export var secondary = "_1x-2";
export var success = "_1x-9";
export var tertiary = "_1x-3";
export var warning = "_1x-7";
export var warningSecondary = "_1x-8";
export var white = "_1x-m";
export var yellow = "_1x-h";